import { Modal } from 'antd';
import { branding } from '../config/branding';

const RestrictionModal = ({ open, setOpen, item = 'this feature' }) => {

    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
        >
            <div style={{ textAlign: 'center' }}>
                <img src={branding.logoSrc} alt={branding.logoAlt} style={{ height: 100 }} />
                <h4 style={{ fontSize: 15 }}>Sorry, {item} is not available in Phodal</h4>
            </div>
        </Modal>
    );
};

export default RestrictionModal;
